export default (() => {
    const tabs = Array.from(document.querySelectorAll('.p-product__tabs li'));
    const sections = Array.from(document.querySelectorAll('.p-product__tab-section'));

    if (tabs.length === 0) return;

    function activateSection(section) {
        [...tabs, ...sections].forEach((item) => item.classList.remove('active'));
        const actives = Array.from(document.querySelectorAll(`[data-section="${section}"]`));
        actives.forEach((item) => item.classList.add('active'));
    }

    tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
            activateSection(tab.dataset.section);
            window.history.replaceState(null, '', `#${tab.dataset.section}`);
        });
    });

    if (window.location.hash) {
        const hash = window.location.hash.substring(1).toLowerCase().replace(/\s+/g, '-');
        activateSection(hash);
        const el = document.querySelector(`[data-section="${hash}"]`);
        if (el) {
            const headerEl = document.querySelector('header');
            const headerOffset = headerEl ? headerEl.offsetHeight : 0;
            const top = el.getBoundingClientRect().top + window.scrollY - headerOffset;
            window.scrollTo({ top, behavior: 'smooth' });
        }
    } else {
        activateSection(tabs[0].dataset.section);
    }

    window.addEventListener('hashchange', () => {
        const hash = window.location.hash.substring(1).toLowerCase().replace(/\s+/g, '-');
        activateSection(hash);
    });
})();
